/**
 * Pure-функция вычисления IS_SHOWCASE — извлечена для testability.
 * Logical core используется в app.module.ts factory'и; adapter там читает
 * `window.location.host` и `environment.showcaseUrl` и зовёт этот резолвер.
 *
 * Правило:
 *   - target пустой/undefined ⇒ false (нет showcase config'а = всегда cabinet)
 *   - target содержит порт (`localhost:4401`) ⇒ строгое посимвольное равенство
 *   - target без порта ⇒ сравнение только по hostname (порт текущего host игнорируем)
 *
 * Почему две ветки: локально cabinet:4200 и showcase:4401 разные сервисы на
 * одном hostname; strip-port дал бы false-positive. В проде target = голый
 * hostname без порта (`nextshowcase.compo-soft.ru`), а текущий host может
 * приходить с портом из nginx upstream — strip нужен.
 */
export function resolveIsShowcase(currentHost: string | null | undefined, target: string | null | undefined): boolean {
  if (!target) return false;
  const t = target.toLowerCase();
  const h = (currentHost ?? '').toLowerCase();
  if (t.includes(':')) {
    return h === t;
  }
  const stripPort = (s: string) => s.split(':')[0];
  return stripPort(h) === stripPort(t);
}
